import api from "./Api";

export interface IFolhaGlobalRubricaItem {
    rubricaId: number;
    bloco: string;
    codigoRubrica: string;
    descricaoRubrica: string | null;
    categoria: string | null;
    valor: number;
    statusMatch: string;
    origemMatch: string | null;
    motivo: string | null;
    cartaoId: number | null;
    contaCartao: string | null;
    lancamentoId: number | null;
}

export interface IFolhaGlobalRubricaFilter {
    page?: number;
    perPage?: number;
    arquivoOperacaoId?: number;
    statusMatch?: string;
}

export interface IFolhaGlobalRubricaPage {
    items: IFolhaGlobalRubricaItem[];
    total: number;
    page: number;
    perPage: number;
    totalPages: number;
}

export interface IFolhaGlobalResumo {
    arquivoOperacaoId: number;
    arquivoProcessou: boolean;
    arquivoErro: boolean;
    arquivoProcessando: boolean;
    periodoReferencia: string | null;
    encontrados: number;
    naoEncontrados: number;
    pendentes: number;
}

// DEVN3-531 — grupos de lançamentos vinculados (ChaveVinculo) numa conta de Salário.
export interface ISalarioLiquidoLancamentoItem {
    id: number;
    dataLancamento: string;
    historico: string | null;
    valor: number;
    tipoLancamento: string;
    origem: string;
    status: string;
}

export interface ISalarioLiquidoGrupo {
    chaveVinculo: string;
    lancamentos: ISalarioLiquidoLancamentoItem[];
}

export interface ISalarioLiquidoResumoCompetencia {
    mes: number;
    ano: number;
    somaLiquido: number;
    somaPagamentos: number;
    diferenca: number;
    vinculado: boolean;
    chaveVinculo: string | null;
}

class FolhaPagamentoGlobalService {
    async iniciarProcessamento(esteiraId: number): Promise<void> {
        await api.post('FolhaPagamentoGlobal/iniciar', { esteiraId });
    }

    async obterResumo(arquivoOperacaoId: number): Promise<IFolhaGlobalResumo> {
        const { data } = await api.get<IFolhaGlobalResumo>(`FolhaPagamentoGlobal/arquivo/${arquivoOperacaoId}/resumo`);
        return data;
    }

    async listarLinhas(esteiraId: number, filter: IFolhaGlobalRubricaFilter): Promise<IFolhaGlobalRubricaPage> {
        const params: Record<string, any> = {
            page: filter.page ?? 1,
            perPage: filter.perPage ?? 20,
        };
        if (filter.arquivoOperacaoId !== undefined) params.arquivoOperacaoId = filter.arquivoOperacaoId;
        if (filter.statusMatch) params.statusMatch = filter.statusMatch;

        const { data } = await api.get<IFolhaGlobalRubricaPage>(
            `FolhaPagamentoGlobal/esteira/${esteiraId}/linhas`,
            { params }
        );
        return data;
    }

    async listarGruposLiquido(esteiraId: number, contaEmpresa: string): Promise<ISalarioLiquidoGrupo[]> {
        const { data } = await api.get<ISalarioLiquidoGrupo[]>(
            `FolhaPagamentoGlobal/esteira/${esteiraId}/conta/${contaEmpresa}/liquido`
        );
        return data;
    }

    async listarResumoLiquido(esteiraId: number, contaEmpresa: string): Promise<ISalarioLiquidoResumoCompetencia[]> {
        const { data } = await api.get<ISalarioLiquidoResumoCompetencia[]>(
            `FolhaPagamentoGlobal/esteira/${esteiraId}/conta/${contaEmpresa}/liquido/resumo`
        );
        return data;
    }
}

export default new FolhaPagamentoGlobalService();
